module.exports = "<select id=\"{{ id }}\" name=\"{{ id }}\" class=\"form-control\" [(ngModel)]=\"selectedValue\" [class.is-invalid]=\"!control.control.valid && submitted\">\r\n  <option [value]=\"c[valueType]\" *ngFor=\"let c of currencies\">{{c.name}}</option>\r\n</select>"


//////////////////
// WEBPACK FOOTER
// /var/www/backend/src/app/shared/components/select-currencies/select-currencies.component.html
// module id = ../../../../../src/app/shared/components/select-currencies/select-currencies.component.html
// module chunks = main